import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import { failureGetSales, successGetSales } from './SalesSlicer';
import { ISalesList } from '../../../Pages/Sales/ISales';
import { PayloadAction } from "@reduxjs/toolkit";
import { Phone } from "@mui/icons-material";

const SalesApi = (action: any) => {
  const { page, pageSize, sortField, sortOrder } = action.payload || {};

  const query = new URLSearchParams();

  if (page !== undefined && pageSize !== undefined) {
    query.append("skip", String(page * pageSize)); // ✅ correct
    query.append("limit", String(pageSize));
  }
  if (sortField) query.append("sortField", sortField);
  if (sortOrder) query.append("sortOrder", sortOrder);
  return api.post(`/parkingActivity/sales?${query.toString()}`);
};

export function* SalesCall(action: any) {
  try {
    const response: AxiosResponse = yield call(SalesApi, action);
    yield put(successGetSales(response.data));
  } catch (error) {
    yield put(failureGetSales(error));
  }
}
const SubscribeApi = (action: any) => {
  const { page, pageSize, location, sortField, sortOrder } =
    action.payload || {};

  const query = new URLSearchParams();

  if (location) query.append("location_id", location);
  if (page !== undefined && pageSize !== undefined) {
    query.append("skip", String(page * pageSize)); // ✅ correct
    query.append("limit", String(pageSize));
  }

  if (sortField) query.append("sortField", sortField);
  if (sortOrder) query.append("sortOrder", sortOrder);
  return api.get(`/parkingActivity/subscribe?${query.toString()}`);
};

// const SubscribeApi = (action: any) => {

//   console.log("action", action.payload);
  
//   const query = action?.payload ? `?location_id=${action.payload}` : "";
//   return api.get(`/parkingActivity/subscribe${query}`);
// };

export function* SubscribeCall(action: any) {
  try {
    const response: AxiosResponse = yield call(SubscribeApi, action);
    yield put(successGetSales(response.data));
  } catch (error) {
    yield put(failureGetSales(error));
  }
}

